import React, { useMemo } from 'react';
import { Listener } from '../../api/listenersApi';
import { createAuthenticatedCaptureClient } from '../../audio/authenticatedCaptureClient';
import { ListenerCaptureTarget } from '../../audio/captureClient';
import { useApp } from '../../context/AppContext';
import GuidedCapture from './GuidedCapture';

interface Props { voiceId: string; voiceName: string; listener: Listener; onComplete: () => void; onCancel: () => void; }
const ListenerPersonalizationFlow: React.FC<Props> = ({ voiceId, voiceName, listener, onComplete, onCancel }) => {
  const { state, trainVoice, fetchVoices } = useApp();
  const draftScopeKey = state.user?.id || 'session';
  const target = useMemo<ListenerCaptureTarget>(() => ({
    kind: 'listener',
    voiceId,
    listenerId: listener.listener_id,
  }), [listener.listener_id, voiceId]);
  const client = useMemo(() => createAuthenticatedCaptureClient({
    draftScopeKey,
    startVoiceBuild: trainVoice,
    refreshVoices: fetchVoices,
    listenerContext: {
      target,
      displayLabel: listener.display_name,
    },
  }), [draftScopeKey, fetchVoices, listener.display_name, target, trainVoice]);
  const speakerDisplayLabel = state.user?.full_name
    || state.user?.name
    || 'your family';

  return (
    <GuidedCapture
      client={client}
      target={target}
      voiceLabel={voiceName}
      speakerDisplayLabel={speakerDisplayLabel}
      listenerDisplayLabel={listener.display_name}
      onComplete={onComplete}
      onCancel={onCancel}
    />
  );
};

export default ListenerPersonalizationFlow;
